import { z } from 'zod';
import { channelKind, isoTimestamp, pageQuery, severity, uuid } from './primitives.js';
export const LABEL_MATCH_OPS = ['eq', 'neq', 'matches'];
export const labelMatchOp = z.enum(LABEL_MATCH_OPS);
export const labelMatcher = z.object({
    key: z.string().min(1).max(128),
    op: labelMatchOp,
    /** For `matches`, a JavaScript regular expression source. */
    value: z.string().max(1024),
});
export const routeMatch = z.object({
    /** Empty means: every source. */
    source_ids: z.array(uuid).max(200).default([]),
    severity_min: severity.default('info'),
    label_matchers: z.array(labelMatcher).max(50).default([]),
    title_contains: z.string().min(1).max(200).nullish(),
});
/** `channel_kind: null` fans out to every active channel the user owns. */
export const routeTarget = z.object({
    user_id: uuid,
    channel_kind: channelKind.nullish(),
});
export const routeTargetResolved = routeTarget.extend({
    user_name: z.string(),
    user_email: z.email(),
});
export const route = z.object({
    id: uuid,
    name: z.string(),
    description: z.string().nullable(),
    priority: z.number().int(),
    is_active: z.boolean(),
    /** When false, a match stops evaluation of lower-priority routes. */
    continue_matching: z.boolean(),
    match: routeMatch,
    targets: z.array(routeTargetResolved),
    created_at: isoTimestamp,
    updated_at: isoTimestamp,
});
export const createRouteBody = z.object({
    name: z.string().min(1).max(120),
    description: z.string().max(2000).nullish(),
    priority: z.number().int().min(0).max(10000).default(100),
    continue_matching: z.boolean().default(true),
    match: routeMatch,
    targets: z.array(routeTarget).min(1, 'Mindestens ein Ziel erforderlich').max(200),
});
export const updateRouteBody = z
    .object({
    name: z.string().min(1).max(120),
    description: z.string().max(2000).nullable(),
    priority: z.number().int().min(0).max(10000),
    is_active: z.boolean(),
    continue_matching: z.boolean(),
    match: routeMatch,
    targets: z.array(routeTarget).min(1).max(200),
})
    .partial()
    .refine((v) => Object.keys(v).length > 0, { message: 'Mindestens ein Feld erforderlich' });
export const listRoutesQuery = pageQuery.extend({
    is_active: z.stringbool().optional(),
});
/** Dry-run: which routes and channels would a hypothetical alert reach? */
export const previewRoutingBody = z.object({
    source_id: uuid,
    severity,
    title: z.string().min(1).max(300).default('Testalarm'),
    labels: z.record(z.string(), z.string()).default({}),
});
export const previewRoutingResponse = z.object({
    matched_routes: z.array(z.object({ id: uuid, name: z.string(), priority: z.number().int() })),
    channels: z.array(z.object({
        channel_id: uuid,
        user_name: z.string(),
        kind: channelKind,
        label: z.string(),
        via_route: z.string(),
    })),
});
//# sourceMappingURL=routes.js.map